import Vue from 'vue'

Vue.filter('bankCode', (value) => {
  return value.toString().padStart(3, '0')
})
